import React, { useContext } from 'react';
import ProjectItem from '../ProjectItem/ProjectItem';
import getProfileData from '../../data/profileData';
import { LanguageContext } from '../../contexts/LanguageContext';
import styles from './SideProjects.module.css';

const SideProjects = () => {
  const { language } = useContext(LanguageContext);
  const { sideProjects, sideProjectsTitle, sideProjectsDescription } = getProfileData(language);

  return (
    <section className={styles.sideProjects}>
      <h2 className={styles.sectionTitle} data-testid="projects-title">{sideProjectsTitle}</h2>
      <p className={styles.sectionDescription}>{sideProjectsDescription}</p>
      <div className={styles.projectsList}>
        {sideProjects.map((project, index) => (
          <ProjectItem key={index} project={project} />
        ))}
      </div>
    </section>
  );
};

export default SideProjects;